import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairportcarrental() {



const cardData = {
  keyword: " Mumbai Airport Car Rental ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai Airport Car Rental services, ensuring a smooth and hassle-free travel experience for airport transfers, business trips, family outings, and city tours. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mumbai Airport convenient and stress-free. We offer flexible booking options including hourly rentals, full-day packages, airport pickups and drops, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, premium cars, and luxury vehicles suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai Airport car rental services.",

topPlaces: [
  
  {
    title: "Hanging Gardens",
    description: "Hanging Gardens on Malabar Hill are beautifully landscaped terraced gardens offering panoramic views of the Arabian Sea and Marine Drive. Travelers choosing an Innova Crysta on rent in Pune can relax amidst well-maintained greenery, unique topiary displays, and peaceful surroundings while enjoying one of Mumbai's most scenic viewpoints."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is among Mumbai's most popular coastal attractions, known for its lively atmosphere, delicious street food, and spectacular sunsets. Visitors renting an Innova Crysta in Pune can comfortably travel to Mumbai and spend quality time enjoying beach walks, local snacks, and family-friendly entertainment."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is a remarkable meditation monument featuring one of the world's largest stone domes. Travelers booking an Innova Crysta on rent in Pune can enjoy a scenic drive to this peaceful destination near Gorai and experience meditation, spiritual learning, and impressive architecture surrounded by serene landscapes."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a picturesque urban lake surrounded by gardens, restaurants, and modern city landmarks. Hiring an Innova Crysta on rent in Pune provides a smooth journey for families and groups looking to enjoy lakeside views, peaceful walks, boating, and quality leisure time in one of Mumbai's most attractive neighborhoods."
  },
  {
    title: "Flora Fountain",
    description: "Flora Fountain is a magnificent Victorian monument located in the heart of South Mumbai and surrounded by heritage buildings and bustling business districts. Travelers booking an Innova Crysta on rent in Pune can comfortably explore this iconic landmark while visiting nearby shopping streets, cafés, and colonial-era architecture. It is a great destination for history enthusiasts, photographers, and anyone interested in Mumbai's rich heritage."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive is one of Mumbai's most scenic waterfront promenades, offering breathtaking views of the Arabian Sea and the city's skyline. Visitors choosing an Innova Crysta on rent in Pune can enjoy a comfortable road trip before relaxing by the coastline, taking evening walks, and witnessing the famous sunset that makes Marine Drive one of Mumbai's top attractions."
  },
  {
    title: "Film City, Goregaon",
    description: "Film City in Goregaon is the center of India's entertainment industry and home to numerous Bollywood movie and television sets. Renting an Innova Crysta in Pune makes the journey convenient for families and groups interested in guided studio tours, film sets, and behind-the-scenes experiences of India's vibrant film industry."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is one of Mumbai's most vibrant shopping destinations, offering fashion accessories, handicrafts, antiques, cafés, and street food. Travelers hiring an Innova Crysta on rent in Pune can comfortably explore this lively market while enjoying local shopping and discovering the charm of South Mumbai."
  },
  {
    title: "Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park is a vast green oasis within Mumbai, famous for its wildlife, cycling trails, boating, and lush forests. Booking an Innova Crysta on rent in Pune ensures a comfortable drive to this natural attraction, making it an excellent destination for families, adventure lovers, and nature enthusiasts."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's most iconic historical monument overlooking the Arabian Sea. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this famous landmark, admire its magnificent architecture, enjoy ferry rides to nearby attractions, and capture unforgettable photographs at one of India's most recognized tourist destinations."
  }
],



services: [
{
name: "Car Hire Mumbai Airport",
description: "Car hire Mumbai airport service provides reliable and convenient transportation for travelers arriving at the airport. Passengers can book a wide range of vehicles including sedan, Ertiga, and Innova Crysta depending on their comfort and travel requirements. Professional drivers provide punctual pickups directly from airport terminals and assist with luggage handling. This service is ideal for airport transfers, city travel, and outstation journeys to destinations like Pune, Nashik, and Lonavala. Air-conditioned vehicles, clean interiors, and smooth ride quality ensure a comfortable travel experience. Online booking options allow travelers to reserve cabs in advance with transparent pricing and instant confirmation."
},
{
name: "Airport Cabs Mumbai",
description: "Airport cabs Mumbai service offers dependable transportation for passengers traveling to and from Mumbai airport. Travelers can book comfortable vehicles for pickup and drop services with experienced drivers ensuring safe and timely travel. This service is widely used for airport transfers, business travel, and outstation trips to Pune and nearby destinations. Flexible booking options and 24x7 availability make it convenient for all travelers."
},
{
name: "Mumbai Airport Pickup Taxi Service",
description: "Mumbai airport pickup taxi service provides convenient transportation for passengers arriving at the airport. Professional drivers track flight timings and ensure timely pickup from arrival terminals. Travelers can enjoy comfortable rides in well-maintained vehicles with ample luggage space. This service is ideal for both local travel and long-distance journeys to Pune and nearby cities."
},
{
name: "Mumbai Airport Taxi Fare",
description: "Mumbai airport taxi fare service provides transparent and competitive pricing for passengers booking taxis from the airport. Travelers can choose vehicles based on their budget and comfort preferences including sedan, Ertiga, and Innova. Clear fare structure helps passengers plan their travel expenses easily."
},
{
name: "Airport Cab Booking Mumbai",
description: "Airport cab booking Mumbai allows travelers to easily reserve taxis online for airport transfers and outstation travel. Passengers can select vehicles, check fare details, and confirm bookings instantly. This service ensures reliable transportation with professional drivers and comfortable vehicles."
},
{
name: "Cab Service Mumbai Airport",
description: "Cab service Mumbai airport provides dependable transportation for airport pickup, drop, and outstation travel. Travelers can book comfortable vehicles with experienced drivers for safe journeys to destinations like Pune and nearby cities."
},
{
name: "Innova Airport Drop Mumbai",
description: "Innova airport drop Mumbai service offers premium SUV transportation for airport transfers. The Toyota Innova provides spacious seating, smooth ride quality, and excellent comfort for long-distance travel. Professional drivers ensure timely drop services with safe driving."
},
{
name: "Innova Taxi Mumbai Airport",
description: "Innova taxi Mumbai airport service provides comfortable SUV travel for passengers arriving or departing from the airport. Travelers can enjoy spacious interiors, luggage capacity, and smooth highway performance with professional drivers ensuring safe journeys."
},
{
name: "Mumbai Airport Terminal 2 to Terminal 1 Taxi Fare",
description: "Mumbai airport Terminal 2 to Terminal 1 taxi service provides convenient inter-terminal transfers for passengers. Travelers can quickly reach their next terminal with comfortable vehicles and experienced drivers ensuring timely transfers within the airport area."
},
{
name: "Mumbai International Airport Cab Service",
description: "Mumbai international airport cab service offers reliable transportation for passengers arriving from international destinations. Travelers can book comfortable vehicles for city travel and outstation journeys to Pune and nearby locations with professional drivers ensuring smooth travel."
},
{
name: "Chhatrapati Shivaji Maharaj Airport Cabs",
description: "Chhatrapati Shivaji Maharaj Airport cab service provides dependable transportation for passengers traveling to and from Mumbai airport. Travelers can book vehicles for airport transfers and outstation travel with experienced drivers ensuring safe and comfortable journeys."
},
{
name: "Mumbai Airport to Hadapsar Cab Fare",
description: "Mumbai airport to Hadapsar cab service provides reliable transportation between Mumbai airport and Hadapsar in Pune. Travelers can enjoy smooth expressway travel with comfortable vehicles and professional drivers ensuring timely pickup and drop services."
},
{
name: "Chhatrapati Shivaji Maharaj Terminus to Pune Cab",
description: "Chhatrapati Shivaji Maharaj Terminus to Pune cab service offers convenient transportation between Mumbai railway station and Pune city. Travelers can book comfortable vehicles with professional drivers ensuring safe highway travel."
},
{
name: "Best Mumbai Airport Car Rental Service",
description: "Best Mumbai airport car rental service provides premium transportation with well-maintained vehicles and professional drivers. Travelers can enjoy comfortable rides for airport transfers and outstation journeys with reliable service and transparent pricing."
},
{
name: "Best Car Rental in Mumbai",
description: "Best car rental in Mumbai offers a wide range of vehicles for city travel, airport transfers, and outstation trips. Travelers can choose from sedan, SUV, and luxury vehicles with professional drivers ensuring safe and comfortable journeys."
},
{
name: "Best Car Rental in Mumbai Airport",
description: "Best car rental in Mumbai airport provides convenient transportation options directly from airport terminals. Travelers can book comfortable vehicles with experienced drivers for smooth travel to Pune and nearby destinations."
},
{
name: "Best Car Rental in Mumbai Airport Innova",
description: "Best car rental in Mumbai airport Innova service offers premium SUV transportation for travelers seeking comfort and space. The Innova ensures smooth travel with spacious seating and reliable performance for long-distance journeys."
},
{
name: "7 Seater Innova on Rent in Mumbai",
description: "7 seater Innova on rent in Mumbai provides spacious SUV travel for families and groups. The vehicle offers comfortable seating, air-conditioning, and smooth highway performance for both city and outstation journeys."
},
{
name: "Mumbai Airport Car Rental",
description: "Mumbai airport car rental service provides convenient transportation for travelers arriving at the airport. Passengers can book vehicles for airport pickup, drop, and outstation travel to destinations like Pune with professional drivers ensuring safe journeys."
}
],

tableData: [
["Car Hire Mumbai Airport","Airport Cabs Mumbai"],
["Mumbai Airport Pickup Taxi Service","Mumbai Airport Taxi Fare"],
["Airport Cab Booking Mumbai","Cab Service Mumbai Airport"],
["Innova Airport Drop Mumbai","Innova Taxi Mumbai Airport"],
["Mumbai Airport Terminal 2 to Terminal 1 Taxi Fare","Mumbai International Airport Cab Service"],
["Chhatrapati Shivaji Maharaj Airport Cabs","Mumbai Airport to Hadapsar Cab Fare"],
["Chhatrapati Shivaji Maharaj Terminus to Pune Cab","Best Mumbai Airport Car Rental Service"],
["Best Car Rental in Mumbai","Best Car Rental in Mumbai Airport"],
["Best Car Rental in Mumbai Airport Innova","7 Seater Innova on Rent in Mumbai"],
["Mumbai Airport Car Rental","Mumbai Airport Taxi Service"]
],




whychoose: [
  {
    WhyChooseheading: "Wide Range of Rental Cars",
    WhyChoosedescription: "Velocity Cabs offers a wide range of car rental options at Mumbai Airport including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for all travel needs."
  },
  {
    WhyChooseheading: "Experienced Airport Drivers",
    WhyChoosedescription: "Our drivers are experienced in Mumbai Airport pickups and drop services. They are familiar with Terminal 1 and Terminal 2 routes, ensuring timely pickups and smooth travel."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent pricing for Mumbai Airport car rentals. Customers receive complete fare details including toll charges, parking fees, and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Car Rental Availability",
    WhyChoosedescription: "Our Mumbai Airport car rental service operates 24 hours a day. Whether your flight arrives early morning or late night, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All rental vehicles are fully air-conditioned, well maintained, and regularly sanitized to provide a safe and comfortable travel experience from Mumbai Airport."
  },
  {
    WhyChooseheading: "Flexible Rental Plans",
    WhyChoosedescription: "Velocity Cabs offers flexible car rental options including one-way airport drop, round-trip bookings, hourly rentals, and customized travel plans from Mumbai Airport."
  },
  {
    WhyChooseheading: "Direct Pickup from Airport Terminals",
    WhyChoosedescription: "We provide direct pickup from Mumbai Airport Terminal 1 and Terminal 2 with professional drivers waiting at designated pickup points for hassle-free service."
  },
  {
    WhyChooseheading: "Trusted Airport Rental Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai Airport car rentals thanks to punctual drivers, comfortable vehicles, and professional airport transportation service."
  }
]
};

const faqData = [
  { question: "Do you provide car rental service at Mumbai Airport?", answer: "Yes, Velocity Cabs provides reliable car rental services from Mumbai Airport for local and outstation travel." },
  { question: "Which terminals do you provide pickup from?", answer: "Velocity Cabs provides pickup from both Terminal 1 and Terminal 2 at Mumbai Airport." },
  { question: "Is Mumbai Airport car rental available 24 hours?", answer: "Yes, our car rental service operates 24/7 to match flight schedules." },
  { question: "Which vehicles are available for rental?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way car rental from Mumbai Airport?", answer: "Yes, we provide one-way, round-trip, and hourly rental options from Mumbai Airport." },
  { question: "Do drivers wait at the airport for pickup?", answer: "Yes, our drivers wait at the airport arrival area to ensure smooth passenger pickup." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book the car rental online?", answer: "Yes, customers can easily book Mumbai Airport car rental services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during peak travel hours and holiday seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Deshmukh",
    feedback:
      "The airport transfer in Mumbai was very smooth and well-timed. The cab arrived exactly as scheduled, and the journey to the airport was comfortable and stress-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "Getting a cab for Mumbai Airport was very convenient. The ride was clean, punctual, and the overall experience felt reliable and well-organized.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai Airport Car Rental & Taxi Service | Velocity Cabs",
  "description": "Reliable Mumbai Airport car rental & cab service. Book Innova, Ertiga, or Sedan for airport pickup/drop, one-way or round trips. 24x7 service for Chhatrapati Shivaji Maharaj Airport.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai Airport, Maharashtra, India"
  },
  "serviceType": [
    "Airport Pickup",
    "Airport Drop",
    "Car Rental",
    "Outstation Taxi",
    "One-way/Return Cab"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};







  return (
    <div>
      <Helmet>
  <title>Mumbai Airport Car Rental & Taxi Service | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book reliable car rental & cab service at Mumbai Airport with Velocity Cabs. Innova, Ertiga, Sedan available for one-way, round trip, and airport transfers. 24x7 service."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/59.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairportcarrental;